import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "model-list-item" }
const _hoisted_2 = { class: "model-list-item-content" }
const _hoisted_3 = { class: "body-1 model-list-item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['field-dot', $props.item.status])
      }, null, 2),
      _createElementVNode("span", _hoisted_3, _toDisplayString($props.item.name), 1)
    ])
  ]))
}